module.exports = __webpack_public_path__ + "img/aula.f376cde4.png";